import React from "react";
import { useTranslate } from 'react-redux-multilingual';

const ModalParentStockWms = (props) => {
    const t = useTranslate();
    let sectionCode = props.parentStock.code_id_section[props.wmsid]

    return(
        <div className="table-responsive">
            <table
            id="parent_stock_table"
            className="table"
            >
                <thead>
                    <tr>
                        <th scope="col">{t('items')}</th>
                        <th scope="col" style={{textAlign:'right'}}>{t('quantity')}</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(props.parentStock.by_article).map(([article,value],ind)=>(
                        <tr key={ind}>
                            <td className="lien-quantite" onClick={()=>props.onSelectChild(value.id)}>{article}</td>
                            <td className="text-end">{(value.disponible_by_zone && value.disponible_by_zone[sectionCode] && value.disponible_by_zone[sectionCode][props.zoneid]) || 0}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ModalParentStockWms;
